<template lang="pug">
section.monitoramento
    resultado-pesquisa(v-if='isFiltering', :resultado='resultadoPesquisa')
    .app-view(:class='{ isNotFiltering: !isFiltering }')
        .row
            .col-12
                informacoes-gerais.dados-area-monitorada(
                    v-if='informacoesGerais',
                    :value='informacoesGerais',
                    :qtdAlertasSocioambientas='monitoramentoAlertaIds.length'
                )

        .d-flex.no-gutters.w-100
            .col-9
                .mapa
                    mapa.map-content(
                        :mapConfig='mapConfig',
                        :mapLayersConfigs='mapLayers',
                        :idMapa='"mapaMonitoramento"',
                        :height='"625px"',
                        :menuMaior='true'
                    )

                    legenda(:values='legenda')

            .col-3
                grupos-alerta.menu-alerta(
                    :gruposAlerta='gruposAlerta',
                    :altura='625'
                )

        .row.mt-3
            .col-12
                .card-tabela
                    FiltrosMonitoramento(@getFiltros='filtrar')

                    .areas-moniotradas-container
                        el-input.m-4.col-6.p-0(
                            clearable,
                            v-model='areasMonitoradasRequest.texto',
                            placeholder='Procure pelo nome ou documento da pessoa/produtor ou nome do território',
                            @change='onChangeSearchInput'
                        )
                            i.el-input__icon.el-icon-search(slot='suffix')

                        el-table(
                            :data='areasMonitoradasPaginadas',
                            @sort-change='sortChangeRequest',
                            style='width: 100%',
                            v-loading='loadingMonitoramentoPaginado'
                        )
                            el-table-column(type='expand')
                                template(slot-scope='props')
                                    el-descriptions.descricao-item-tabela(
                                        :size='"mini"'
                                    )
                                        el-descriptions-item(
                                            label='Área de plantio esperada'
                                        ) {{ formatAreaHa(props.row.areaPlantadaEsperadaHa) }}
                                        el-descriptions-item(
                                            label='Cultura esperada'
                                        ) {{ props.row.culturaEsperada != null ? props.row.culturaEsperada.nome : '' }}
                                        el-descriptions-item(
                                            label='Data de plantio esperada'
                                        ) {{ props.row.dataPlantioEsperada ? new Date(props.row.dataPlantioEsperada).toLocaleDateString('pt-BR') : '-' }}

                                        el-descriptions-item(
                                            label='Pessoas/Produtores'
                                        )
                                            .representantes(
                                                v-if='props.row.territorio.representantes && props.row.territorio.representantes.length > 0',
                                                v-for='representante in props.row.territorio.representantes',
                                                :key='representante.id'
                                            )
                                                p {{ representante.nomeRazaoSocial }}
                                                    span ({{ formatCpfCnpj(representante.cpfCnpj) }})&nbsp

                                            p(
                                                v-if='!props.row.territorio.representantes || props.row.territorio.representantes.length === 0'
                                            ) Esse território não possui representantes vinculados
                            .monitoramento
                            el-table-column(
                                label='Nome',
                                min-width='180',
                                sortable='custom'
                            )
                                .template(slot-scope='scope')
                                    span
                                        | {{ scope.row.territorio ? scope.row.territorio.nome : '-' }}
                                    span.alerta(
                                        v-show='scope.row.alertas.length > 0|| (monitoramentoAlertaIds.includes(scope.row.id) && scope.row.tipoMonitoramento.nome === \'Socioambiental\')'
                                    )
                                        | alerta
                            el-table-column(label='Tipo', min-width='140')
                                .template(slot-scope='scope')
                                    div
                                        | {{ scope.row.tipoMonitoramento ? scope.row.tipoMonitoramento.nome : '-' }}
                            el-table-column(
                                label='Situação Colheita',
                                min-width='110'
                            )
                                .template(slot-scope='scope')
                                    p(
                                        v-if='scope.row.tipoMonitoramento.nome !== "Socioambiental"'
                                    )
                                        span {{ updateStatusColheita(scope.row.statusColheita) }}
                                    p(v-else)
                                        span -

                            el-table-column(label='Pessoa', min-width='200')
                                .template(slot-scope='scope')
                                    el-tooltip(
                                        v-if='scope.row.territorio.representantes && scope.row.territorio.representantes.length > 0',
                                        effect='light',
                                        placement='top',
                                        :content='listarRepresentante(scope.row.territorio.representantes)'
                                    )
                                        p(
                                            v-if='scope.row.territorio.representantes && scope.row.territorio.representantes.length > 0'
                                        ) {{ scope.row.territorio.representantes[0].nomeRazaoSocial }}
                                            span ({{ formatCpfCnpj(scope.row.territorio.representantes[0].cpfCnpj) }})
                                            el-tag.ml-2(
                                                v-if='scope.row.territorio.representantes.length > 1',
                                                size='mini'
                                            )
                                                | {{ scope.row.territorio.representantes.length - 1 }}

                                        p(v-else) -
                                    span(v-else) -

                            el-table-column(label='Status', min-width='100')
                                .template(slot-scope='scope')
                                    span {{ scope.row.statusVegaApi === 'ATIVO' ? 'Ativo' : 'Cancelado' }}

                            el-table-column(label='Safra', min-width='100')
                                .template(slot-scope='scope')
                                    p(
                                        v-if='scope.row.tipoMonitoramento.nome !== "Socioambiental"'
                                    )
                                        span {{ scope.row.safra.descricao }}
                                    p(v-else)
                                        span -

                            el-table-column(
                                min-width='70',
                                align='center',
                                label='Ações'
                            )
                                .template(slot-scope='scope')
                                    el-dropdown.action-button(trigger='click')
                                        span.el-dropdown-link
                                            i.mdi.mdi-dots-vertical

                                        el-dropdown-menu(
                                            v-if='scope.row.tipoMonitoramento.nome == "Socioambiental"',
                                            slot='dropdown'
                                        )
                                            el-tooltip(
                                                v-if='scope.row.statusVegaApi === "CANCELADO"',
                                                content='Visualização não disponível',
                                                placement='top'
                                            )
                                                el-dropdown-item.disabled(
                                                    icon='el-icon-view'
                                                ) Visualizar
                                            el-dropdown-item(
                                                v-else,
                                                icon='el-icon-view',
                                                @click.native='goToAreaMonitorada(scope.row)'
                                            ) Visualizar

                                            div(
                                                v-if='usuarioLogado.monitoramentoAccess && usuarioLogado.monitoramentoEnviar'
                                            )
                                                el-dropdown-item(
                                                    v-if='scope.row.statusVegaApi === "ATIVO"',
                                                    icon='el-icon-remove',
                                                    @click.native='abrirModalCancelarMonitoramento(scope.row)'
                                                ) Cancelar

                                                el-dropdown-item(
                                                    v-else,
                                                    icon='el-icon-refresh-left',
                                                    @click.native='abrirModalReativarMonitoramento(scope.row)'
                                                ) Reativar monitoramento

                                        el-dropdown-menu(
                                            v-else,
                                            slot='dropdown'
                                        )
                                            el-dropdown-item(
                                                icon='el-icon-view',
                                                @click.native='goToAreaMonitorada(scope.row)'
                                            ) Visualizar
                                            el-dropdown-item(
                                                v-if='scope.row.statusVegaApi === "ATIVO"',
                                                icon='el-icon-edit',
                                                @click.native='updateAreaMonitorada(scope.row)'
                                            ) Editar

                                            el-dropdown-item(
                                                v-show='scope.row.statusVegaApi === \'ATIVO\'',
                                                icon='el-icon-circle-plus-outline',
                                                @click.native='adicionarNovoCiclo(scope.row)'
                                            ) Adicionar Novo Ciclo

                                            el-dropdown-item(
                                                v-if='scope.row.statusVegaApi === "ATIVO"',
                                                icon='el-icon-remove',
                                                @click.native='abrirModalCancelarMonitoramento(scope.row)'
                                            ) Cancelar

                                            el-dropdown-item(
                                                v-else,
                                                icon='el-icon-refresh-left',
                                                @click.native='abrirModalReativarMonitoramento(scope.row)'
                                            ) Reativar monitoramento

                            template(slot='empty')
                                el-empty(
                                    description='Você ainda não possui nenhuma área em monitoramento'
                                )

                        .py-3(style='text-align: center')
                            el-pagination(
                                background,
                                :page-size='paginaRequest.size',
                                :current-page.sync='paginaRequest.page',
                                layout='prev, pager, next',
                                :total='totalAreasMonitoradas',
                                @current-change='atualizarPagina'
                            )

    SendOrEditMonitoramento(
        v-if='showMonitoramentoModal',
        :selectedTerritorioNome='territorioParaMonitoramento.nome',
        :selectedTerritorio='territorioParaMonitoramento',
        :actionType='acao',
        @atualizado='updateRequests()'
    )
        #modal-cancelar-monitoramento
            el-dialog(
                :visible.sync='mostrarModalCancelarMonitoramento',
                width='500px',
                :before-close='fecharModalCancelarMonitoramento'
            )
                span(slot='title')
                    h1.font-weight-bold Cancelar Monitoramento
                    h2 {{ territorioSelecionado.nome }}
                p Tem certeza que deseja cancelar o monitoramento deste território?
                .buttons
                    BaseButton(
                        size='mini',
                        @click='fecharModalCancelarMonitoramento'
                    )
                        | Voltar
                    BaseButton(
                        type='primary',
                        size='mini',
                        @click='cancelarMonitoramento'
                    )
                        | Cancelar Monitoramento

    #modal-reativar-monitoramento
        el-dialog(
            :visible.sync='mostrarModalReativarMonitoramento',
            width='500px',
            :before-close='fecharModalReativarMonitoramento'
        )
            span(slot='title')
                h1.font-weight-bold Reativar Monitoramento
                h2 {{ territorioSelecionado.nome }}
            p Tem certeza que deseja reativar o monitoramento deste território?
            .buttons
                BaseButton(
                    size='mini',
                    @click='fecharModalReativarMonitoramento'
                )
                    | Voltar
                BaseButton(
                    type='primary',
                    size='mini',
                    @click='reativarMonitoramento'
                )
                    | Reativar Monitoramento
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

import GruposAlerta from '@/components/GruposAlerta';
import ResultadoPesquisa from '@/components/ResultadoPesquisa';
import InformacoesGerais from '@/components/quantitativos/InformacoesGerais';
import InformacoesMonitoramento from '@/components/quantitativos/InformacoesMonitoramento';
import Legenda from '@/components/Legenda';
import Mapa from '@/components/MapaLeaflet';
import FiltrosMonitoramento from '@/components/FiltrosMonitoramento';

import UtilsService from '@/services/UtilsService';
import clienteService from '@/services/ClienteService';
import AreasMonitoradasService from '@/services/AreasMonitoradasService';
import { LEGENDA_MAPA_INICIAL } from '@/utils/layouts/legendas';
import formatters from '@/utils/formatters';
import SendOrEditMonitoramento from '@/components/areamonitorada/SendOrEditMonitoramento';

import MonitoramentoService from '@/services/MonitoramentoService';
import AlertaService from '@/services/AlertaService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'index',

    components: {
        Legenda,
        GruposAlerta,
        ResultadoPesquisa,
        InformacoesGerais,
        InformacoesMonitoramento,
        Mapa,
        SendOrEditMonitoramento,
        FiltrosMonitoramento,
        BaseButton
    },

    data() {
        return {
            carregando: true,
            areasMonitoradasPaginadas: [],
            totalAreasMonitoradas: 0,
            informacoesGerais: null,
            resultadoPesquisa: [],
            areasMonitoradas: [],
            gruposAlerta: [],
            mapLayers: null,
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    ferramentasControl: true
                },
                inspecionar: true,
                diagnostico: true
            },
            legenda: LEGENDA_MAPA_INICIAL,
            searchText: null,
            acao: 'edit',
            territorioParaMonitoramento: {},
            mostrarModalCancelarMonitoramento: false,
            mostrarModalReativarMonitoramento: false,
            territorioSelecionado: {},
            idAreaMonitoradaSelecionada: null,
            tipoMonitoramentoSelecionado: '',
            cancelarTipoMonitoramento: [],
            tipoMonitoramento: {
                Agrícola: 'AGRICOLA',
                Socioambiental: 'SOCIOAMBIENTAL',
                'Agrícola,Socioambiental': 'AGRICOLA_E_SOCIOAMBIENTAL',
                'Socioambiental,Agrícola': 'AGRICOLA_E_SOCIOAMBIENTAL'
            },
            monitoramentoAlertaIds: [],
            areasMonitoradasRequest: {
                texto: ''
            },
            paginaRequest: {
                page: 1,
                size: 20,
                sort: 'data_cadastro,DESC'
            },
            loadingMonitoramentoPaginado: false
        };
    },

    computed: {
        ...mapGetters([
            'filtro',
            'culturaSelecionada',
            'isFiltering',
            'showMonitoramentoModal'
        ]),

        ...mapState(['usuarioLogado'])
    },

    created() {
        this.updateRequests();
    },

    methods: {
        ...mapActions(['changeShowMonitoramentoModal']),
        findDadosQuantitativos() {
            AreasMonitoradasService.getQuantitativos(this.filtro).then(
                result => {
                    if (result.status === 200) {
                        this.informacoesGerais = result.data;
                    } else {
                        this.$notify.error({
                            message:
                                'Ocorreu um erro ao buscar os quantitativos de áreas'
                        });
                    }
                }
            );
        },
        listarRepresentante(representante) {
            let representantes = '';
            for (const item in representante) {
                representantes += representante[item].nomeRazaoSocial + ', ';
            }
            return representantes.substring(0, representantes.length - 2);
        },
        findAlertas() {
            UtilsService.findAlertas(this.filtro)
                .then(result => {
                    this.gruposAlerta = result.data.filter(item => {
                        if (item.id !== 4) return item;
                    });

                    AlertaService.findAreaMonitoradaWithAlerta().then(
                        ({ data }) => {
                            Object.keys(this.gruposAlerta).forEach(item => {
                                /* if (this.gruposAlerta[item].nome === 'Monitoramento da fase de plantio') {
                                    this.gruposAlerta[item].nome = 'Alertas de monitoramento da fase de plantio';
                                } */
                                if (
                                    this.gruposAlerta[item].nome ===
                                    'Monitoramento da produtividade'
                                ) {
                                    this.gruposAlerta[item].nome =
                                        'Alertas de monitoramento da produtividade';
                                }
                                if (
                                    this.gruposAlerta[item].nome ===
                                    'Monitoramento de Colheita'
                                ) {
                                    this.gruposAlerta[item].nome =
                                        'Alertas de monitoramento de colheita';
                                }
                                if (
                                    this.gruposAlerta[item].nome ===
                                    'Alertas socioambientais'
                                ) {
                                    this.gruposAlerta[item].alertas = data;
                                }
                            });

                            this.monitoramentoAlertaIds = [];
                            data.forEach(({ id }) => {
                                this.monitoramentoAlertaIds.push(id);
                            });
                        }
                    );
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Ocorreu um erro ao buscar os alertas'
                    });
                });
        },
        updateStatusColheita(colheita) {
            if (colheita === 'COLHIDO') {
                return 'Colhido';
            } else {
                if (colheita === 'NAO_COLHIDO' || !colheita) {
                    return 'Não colhido';
                } else {
                    return 'Em colheita';
                }
            }
        },
        atualizarPagina() {
            this.findAreasMonitoradasPaginado();
            this.findAreasMonitoradasMapa();
        },

        findResultadoPesquisa() {
            clienteService.findByFiltro(this.filtro).then(result => {
                this.resultadoPesquisa = result.data;
            });
        },

        findAreasMonitoradasMapa() {
            AreasMonitoradasService.findByFiltro(this.filtro).then(result => {
                if (result.status === 200) {
                    this.areasMonitoradas = result.data;
                    this.configureLayersMapa();
                } else {
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar os dados das áreas monitoradas'
                    });
                }
            });
        },

        findAreasMonitoradasPaginado() {
            this.limparTextoBusca();
            if (
                this.areasMonitoradasRequest.texto.length === 0 ||
                this.areasMonitoradasRequest.texto.length > 2
            ) {
                this.loadingMonitoramentoPaginado = true;
                AreasMonitoradasService.findByFiltroPaginado(
                    this.areasMonitoradasRequest,
                    this.paginaRequest
                )
                    .then(({ data }) => {
                        this.areasMonitoradasPaginadas = data.resultados;
                        this.totalAreasMonitoradas = data.totalResultados;
                        if (!this.areasMonitoradasRequest.texto) {
                            this.areasMonitoradasRequest = { texto: '' };
                        }
                        this.loadingMonitoramentoPaginado = false;
                    })
                    .catch(() => {
                        this.$notify.error({
                            message:
                                'Ocorreu um erro ao buscar os dados das áreas monitoradas'
                        });
                    });
            } else {
                this.$notify.warning({
                    message: 'Digite no mínimo 3 caracteres para pesquisar.'
                });
            }
        },

        updateRequests() {
            this.findDadosQuantitativos();

            this.findAlertas();

            this.findAreasMonitoradasMapa();

            this.findAreasMonitoradasPaginado();

            if (this.isFiltering) {
                this.findResultadoPesquisa();
            }
        },
        configureLayersMapa() {
            this.mapLayers = [];

            _.each(this.areasMonitoradas, areaMonitorada => {
                this.mapLayers.push({
                    name: 'centroid' + areaMonitorada.id,
                    geoJson: areaMonitorada.centroide,
                    tipoCultura:
                        areaMonitorada.culturaEsperada === null
                            ? null
                            : areaMonitorada.culturaEsperada.codigo,
                    popup: this.getPopupAreaMonitorada(areaMonitorada),
                    tooltip: this.getTooltipAreaMonitorada(areaMonitorada)
                });
            });
        },

        getPopupAreaMonitorada(areaMonitorada) {
            return areaMonitorada
                ? `<h5><b>Área monitorada ${
                        areaMonitorada.territorio.nome
                    }</b></h5>
                    <br>
                    <h6>Tipo de monitoramento: ${areaMonitorada.tipoMonitoramento.nome}</h6>
                    <br/>
                    <div>
                        <b>Cultura: </b>
                        ${
                            areaMonitorada.culturaEsperada != null
                                ? areaMonitorada.culturaEsperada.nome
                                : 'Não Identificada'
                        }
					</div>
					<br>
					<a id='detalhesAreaMonitorada' style='color: #01A3A4; cursor: pointer; text-decoration: underline' onClick="window.location.replace('#/area-monitorada/${
                        areaMonitorada.id
                    }', '_blank'); window.location.reload()">Mais detalhes</a>
                    <br>`
                : '';
        },

        getTooltipAreaMonitorada(areaMonitorada) {
            if (!areaMonitorada) return null;

            let tooltip = `Área monitorada: ${areaMonitorada.territorio.nome} <br /> <ul>`;

            if (
                areaMonitorada.tipoMonitoramento.codigo === 'SOCIOAMBIENTAL' ||
                areaMonitorada.tipoMonitoramento.codigo ===
                    'AGRICOLA_E_SOCIOAMBIENTAL'
            ) {
                tooltip += '<li>Monitoramento socioambiental</li>';
            }

            if (
                areaMonitorada.tipoMonitoramento.codigo === 'AGRICOLA' ||
                areaMonitorada.tipoMonitoramento.codigo ===
                    'AGRICOLA_E_SOCIOAMBIENTAL'
            ) {
                tooltip += '<li>Monitoramento agrícola</li>';
            }

            if (areaMonitorada.culturaEsperada) {
                tooltip += `<li>Cultura esperada: ${areaMonitorada.culturaEsperada.nome}</li>`;
            }

            return tooltip + '</ul>';
        },

        onChangeSearchInput() {
            this.paginaRequest.page = 1;
            this.findAreasMonitoradasPaginado();
        },

        goToAreaMonitorada(row) {
            this.$router.push({
                name: 'AreaMonitorada',
                params: { idAreaMonitorada: row.id }
            });
        },

        setDados(row) {
            this.territorioParaMonitoramento.id = row.id;
            this.territorioParaMonitoramento.nome = row.territorio.nome;
            this.territorioParaMonitoramento.idTerritorio = row.territorio.id;
            this.territorioParaMonitoramento.tipoMonitoramento =
                row.tipoMonitoramento;
            if (row.tipoMonitoramento.codigo !== 'SOCIOAMBIENTAL') {
                this.territorioParaMonitoramento.idSafra = row.safra.id;
                this.territorioParaMonitoramento.cultura = row.culturaEsperada;
                this.territorioParaMonitoramento.dataPlantio =
                    row.dataPlantioEsperada;
                this.territorioParaMonitoramento.areaDoPlantio =
                    row.areaPlantadaEsperadaHa;
                this.territorioParaMonitoramento.produtividade =
                    row.produtividadeEsperadaScHa;
            } else {
                this.territorioParaMonitoramento.idSafra = '';
                this.territorioParaMonitoramento.cultura = '';
                this.territorioParaMonitoramento.dataPlantio = '';
                this.territorioParaMonitoramento.areaDoPlantio = '';
                this.territorioParaMonitoramento.produtividade = '';
            }
        },

        adicionarNovoCiclo(row) {
            this.acao = 'addCiclo';
            this.setDados(row);
            this.changeShowMonitoramentoModal();
        },

        formatCpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },

        formatAreaHa(areaHa) {
            return formatters.formatNumber(areaHa, 2);
        },

        updateAreaMonitorada(row) {
            this.acao = 'edit';
            this.setDados(row);
            this.changeShowMonitoramentoModal();
        },

        handleCloseModalSendToMonitoramento() {
            this.changeShowMonitoramentoModal();
            this.clearAll();
        },

        clearAll() {
            this.clearSendToMonitoramento();
        },

        clearSendToMonitoramento() {
            this.territorioParaMonitoramento = {};
        },

        abrirModalCancelarMonitoramento({ id, territorio }) {
            this.idAreaMonitoradaSelecionada = id;
            this.territorioSelecionado = territorio;
            this.mostrarModalCancelarMonitoramento = true;
        },

        fecharModalCancelarMonitoramento() {
            this.mostrarModalCancelarMonitoramento = false;
        },

        cancelarMonitoramento() {
            MonitoramentoService.cancelarMonitoramento(
                this.idAreaMonitoradaSelecionada
            )
                .then(() => {
                    this.$notify.success({
                        message: `Monitoramento ${
                            this.cancelarTipoMonitoramento.length === 2
                                ? ''
                                : this.cancelarTipoMonitoramento.toString()
                        } cancelado com sucesso`
                    });
                    this.fecharModalCancelarMonitoramento();
                    this.updateRequests();
                    this.atualizarPagina();
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Não foi possível cancelar o monitoramento'
                    });
                });
        },

        sortChangeRequest({ column, order }) {
            const ordem = order === 'ascending' ? 'ASC' : 'DESC';
            const campoOrdenacao =
                column.label === 'Nome' ? 'nome' : 'data_cadastro';
            this.paginaRequest.sort = `${campoOrdenacao},${ordem}`;

            this.findAreasMonitoradasPaginado();
        },

        limparTextoBusca() {
            if (this.areasMonitoradasRequest.texto) {
                const cpfCnpj = formatters.documentoFormatToNumeral(
                    this.areasMonitoradasRequest.texto
                );
                this.areasMonitoradasRequest.texto =
                    cpfCnpj === ''
                        ? this.areasMonitoradasRequest.texto
                        : cpfCnpj;
            } else {
                this.areasMonitoradasRequest.texto = '';
            }
        },

        filtrar(filtro) {
            this.areasMonitoradasRequest = filtro;
            this.findAreasMonitoradasPaginado();
        },

        abrirModalReativarMonitoramento({ id, territorio }) {
            this.idAreaMonitoradaSelecionada = id;
            this.territorioSelecionado = territorio;
            this.mostrarModalReativarMonitoramento = true;
        },

        fecharModalReativarMonitoramento() {
            this.mostrarModalReativarMonitoramento = false;
        },

        reativarMonitoramento() {
            MonitoramentoService.reativarMonitoramento(
                this.idAreaMonitoradaSelecionada
            )
                .then(() => {
                    this.updateRequests();
                    this.fecharModalReativarMonitoramento();
                    this.$notify.success({
                        message: 'Monitoramento reativado com sucesso!'
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Não foi possível reativar o monitoramento'
                    });
                });
        }
    }
};
</script>

<style lang="scss">
.monitoramento {
    width: 100%;
    height: calc(100vh - 65px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 20px;

    .alerta {
        font-size: 12px;
        color: #616266;
        background-color: #f7d7da;
        border-color: #f5c6cb;
        border-radius: 4px;
        margin-left: 8px;
        padding: 0 4px;
        font-style: italic;
    }

    .areas-moniotradas-container {
        width: 100%;
        background-color: var(--white);
        border-radius: 4px;
    }

    .el-table {
        .cell {
            word-break: break-word !important;
        }

        .action-button {
            cursor: pointer;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
    }

    .card-tabela {
        background-color: var(--white);
        border-radius: 4px;
        overflow: hidden;
    }
}

.menu-alerta {
    border-radius: 0 4px 4px 0;
}

.dados-area-monitorada {
    margin-bottom: 15px;
}

.mapa {
    position: relative;
    z-index: 1;
    border-radius: 5px 0 0 5px !important;
    overflow: hidden;
}

.disabled,
.disabled:hover {
    color: #ccc;
}

#modal-cancelar-monitoramento,
#modal-reativar-monitoramento {
    p {
        margin-top: -15px;
    }

    .buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        margin-bottom: -10px;
    }
}
</style>
